<div class="custom-badge-container">
  <button
    mat-icon-button
    [class.active]="isCommentsChatOpened"
    (click)="onMessagesTabIconClick()"
  >
    <mat-icon>chat</mat-icon>
  </button>

  <!-- Custom Badge -->
    <span
      class="custom-badge"
    >
      {{ getBadgeText(commentsOnEntityDialogOpenerButtonService.numberOfComments$ | async) }}
    </span>
</div>
